module.exports = __webpack_public_path__ + "static/media/companyselected.8008e8ec.png";